<script lang="ts">

    import { Component, Prop } from "vue-facing-decorator";
    import { AnalyticsCustomEvent, GTMUtils, TranslationKey } from "webshop-modules";
    import { Vue } from "vue-facing-decorator";
    import { LogoDTO } from "@/domain/main-header/dto/Logo.dto";

    @Component({})
    export default class LogoComponent extends Vue {
        @Prop()
        public logo!: LogoDTO;

        public readonly Translation: typeof TranslationKey = TranslationKey;

        public handleLogoClick() {
            const eventData: AnalyticsCustomEvent = {
                event: 'main_navigation_click',
                click_text: 'logo'
            };

            GTMUtils.pushAnalyticsEventToDataLayer(eventData);
        }

    }
</script>

<template>
    <a
        :class="['o-mainHeader__logo', {'is-svg': logo.isSvg}]"
        :href="logo.url"
        :title="logo.name"
        data-js="logo"
        v-on:click="handleLogoClick">
        <picture class="a-picture">
            <img class="o-mainHeader__logoImg" id="logo" itemprop="image"
                :alt="logo.description"
                :src="logo.imgPath">
        </picture>
    </a>
</template>
